"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";
import Collapse from "../Collapse";
import Link from "next/link";

const CollapseItem = ({ item }: any) => {
  const [open, setIsOpen] = useState(false);

  return (
    <div
      onClick={() => setIsOpen(!open)}
      className={cn("mb-4 w-full cursor-pointer")}
    >
      <div className="flex w-full items-center justify-between gap-4">
        <p className="text-base text-white">{item.title}</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 7.91663L9.88215 12.8671C9.94724 12.9331 10.0528 12.9331 10.1179 12.8671L15 7.91663"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <Collapse open={open} timeout="auto" unmountOnExit>
        {item?.links?.map((link: any, index: number) => (
          <Link key={index} href={link.href}>
            <p className="px-6 py-2 text-sm font-normal text-white/[0.64] md:text-base">
              {link.title}
            </p>
          </Link>
        ))}
      </Collapse>
    </div>
  );
};

export default CollapseItem;
